import { demi, heavy, midBig, normal } from 'components/calls/styles/fonts';
import { FullScreenContent } from 'components/calls/templates/Screen';
import styled, { css } from 'styled-components';
import { getImageUrl, media, when } from 'utils';

export const Content = styled(FullScreenContent)`
  background: #555358;
  display: flex;
  flex-direction: row;
  height: 99vh;
  width: 100%;
`;

export const Main = styled.div<{ show: boolean; recording: boolean }>`
  display: flex;
  width: 100%;
  margin: auto;

  ${when('recording')`
    border: 1px solid red;
    border-radius: 2px;
  `}

  ${(props) =>
    props.show &&
    css`
      width: calc(100% - 376px);

      ${media.tablet`
        width: 100%;
      `}
    `};
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 88px;
  padding: 0 48px;
  color: white;
  background-color: #202025;
  display: flex;
  justify-content: space-between;
  z-index: 20;

  ${media.mobileL`
    padding: 0 20px  ;

  `}
`;

export const Button = styled.div`
  width: 80px;
  height: 88px;
  padding: 20px 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  ${normal};
  ${heavy};
  letter-spacing: -0.1px;
  ${media.mobileL`
    width:40px ;
    height:88px ;
    font-size:10px ;
    padding: 25px 15px;
  `}
  ${media.mobile`
  width:30px ;
  `}
`;

export const ButtonIcon = styled.div<{ src: string }>`
  background-image: ${(props) => getImageUrl(props.src)};
  background-repeat: no-repeat;
  background-position: center;
  width: 24px;
  height: 24px;
  ${media.mobileL`
  width: 24px;
  height: 24px;
    background-size:16px !important;
  `}
`;

export const UtilityButtons = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Side = styled.div<{ show: boolean }>`
  z-index: 10;
  width: 376px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  min-height: calc(100vh - 80px - 88px);
  padding: 2rem;

  background-color: rgba(255, 255, 255, 1);
  ${(props) =>
    props.show
      ? css`
          display: block;
        `
      : css`
          display: none;
        `};

  @media (max-width: 568px) {
    width: 90%;
    min-height: 300px;
    border-radius: 4px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const SideTitle = styled.div`
  padding: 5px 20px;
  ${midBig};
  ${demi};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid var(--navy-100);
`;

export const SideClose = styled.div`
  width: 32px;
  height: 32px;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;

  > div {
    width: 20px;
    height: 20px;
    background-image: ${getImageUrl('/icons/ic-close.svg')};
    background-repeat: no-repeat;
    background-position: center center;
  }
`;

export const Participants = styled.div`
  width: 100%;
  padding: 0 10px;
  flex: 1;
`;


export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;

export const ShareWrapper = styled.div`
  padding-top: 20px;
  label {
    font-size: 18px;
    font-weight: 700;
  }
`;

export const CenterDiv = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;
